var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMultiStatusIcon = function SvgMultiStatusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13536_16300)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.62641 10.4167C3.90052 10.4181 2.50252 11.8183 2.50391 13.5442C2.50529 15.2701 3.90552 16.6681 5.63141 16.6667C7.35632 16.6653 8.75391 15.2666 8.75391 13.5417C8.75391 11.8154 7.35442 10.4167 5.62807 10.4167C5.6278 10.4167 5.62669 10.4167 5.62641 10.4167ZM14.3714 10.4167C12.6455 10.4181 11.2475 11.8183 11.2489 13.5442C11.2503 15.2701 12.6505 16.6681 14.3764 16.6667C16.1013 16.6653 17.4989 15.2666 17.4989 13.5417C17.4989 11.8154 16.0994 10.4167 14.3731 10.4167C14.3728 10.4167 14.3717 10.4167 14.3714 10.4167ZM9.99891 2.85339C8.27302 2.85477 6.87502 4.255 6.87641 5.98089C6.87779 7.70679 8.27802 9.10478 10.0039 9.10339C11.7288 9.10201 13.1264 7.70331 13.1264 5.97839C13.1264 4.25204 11.7269 2.85339 10.0006 2.85339C10.0003 2.85339 9.99919 2.85339 9.99891 2.85339Z",
    stroke: "#F2F2F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13536_16300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
export { SvgMultiStatusIcon as ReactComponent };
export default __webpack_public_path__ + "multi-status-icon.svg";